import _ from 'lodash';
import uomApi from '@/api/uomApi';
import { fetchOnce } from '@/store/utils/fetchOnce';

export default {
	namespace: true,

	state: {
		uoms: {},
		uomsLoaded: false
	},

	mutations: {
		SET_ALL_UOMS(state, uoms) {
			state.uoms = uoms;
		},
		SET_UOMS_LOADED(state, val) {
			state.uomsLoaded = val;
		}
	},

	actions: {
		setAllUoms(vuexContext, uoms) {
			vuexContext.commit('SET_ALL_UOMS', uoms);
		},
		fetchUomsIfNeeded({ state, commit }, { currUserId }) {
			if (state.uomsLoaded) return Promise.resolve();
			return fetchOnce('uoms', () =>
				uomApi.getUoms(currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_UOMS', data.uoms);
						commit('SET_UOMS_LOADED', true);
					}
					return data;
				})
			);
		}
	},

	getters: {
		uoms(state) {
			if (!_.isEmpty(state.uoms)) {
				return state.uoms;
			}
			return {};
		},
	}
}
